export default class spiltBillCommitModCtrl {
    constructor($scope, $uibModalInstance, items1, httpRequest, logger, Upload, $timeout, $rootScope, $uibModal, globalFn, $location, $state) {
        $scope.items = items1
        for (let i = 0, l = $scope.items.commitDataList.length; i < l; i++) {
            let data = 0
            for (const a in $scope.items.commitDataList[i].data) {
                data = globalFn.Add(data, $scope.items.commitDataList[i].data[a].amount)
            }
            $scope.items.commitDataList[i].data = data
        }

        $scope.ok = function () {
            // $location.path("outputManage.FOManage.ovatBill.list").replace()
            $state.go('outputManage.FOManage.ovatBill.list')

            $uibModalInstance.close()
            // console.log('万事大吉,今晚吃鸡')
        }
        $scope.cancel = function cancel() {
            $uibModalInstance.close()
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/spiltBillCommitModCtrl.js